import React from 'react'
import { Input, Label } from 'reactstrap'

import { useCartRedux } from '@hooks'

const ComplimentaryOrder = () => {
    const { isComplimentaryOrder, complimentaryOrderReason, setIsComplimentaryOrder, setComplimentaryOrderReason } =
        useCartRedux()

    const handleToggle = e => {
        const isChecked = e.target.checked
        setIsComplimentaryOrder(isChecked)
    }

    return (
        <div className="complimentary-order-section">
            <div className="d-flex align-items-center justify-content-between">
                <Label className="complimentary-order-label mb-0" style={{ cursor: 'pointer' }}>
                    Complimentary Order
                </Label>
                <div className="form-check form-switch">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="complimentaryOrderSwitch"
                        checked={isComplimentaryOrder}
                        onChange={handleToggle}
                    />
                </div>
            </div>
            {isComplimentaryOrder && (
                <div className="mt-3">
                    <Label for="complimentaryOrderReason" className="complimentary-order-label">
                        Reason (Required)
                    </Label>
                    <Input
                        id="complimentaryOrderReason"
                        type="textarea"
                        rows="2"
                        value={complimentaryOrderReason}
                        onChange={e => setComplimentaryOrderReason(e.target.value)}
                        placeholder="Please enter the reason here..."
                        className="mt-1"
                        required
                    />
                </div>
            )}
        </div>
    )
}

export default ComplimentaryOrder
